import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { UpdateUserEmail } from "./UpdateUserEmail";

interface IParams {
    email: string;
}

export const UserEmail = (props: IParams) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation("profile");
    const { email } = props;

    const onFinishUpdate = () => {
        setIsEditing(false);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    return isEditing ? (
        <UpdateUserEmail
            handleCancelClick={() => setIsEditing(false)}
            oldEmail={email}
            onFinishUpdate={onFinishUpdate}
        />
    ) : (
        <Fragment>
            <Modal
                close={closeModal}
                confirm={closeModal}
                content={<Trans i18nKey="emailChange" ns="profile" />}
                isModalOpen={isModalOpen}
                title={t("emailSuccess")}
            />
            <Grid alignItems="center" className="mydetail__fields" container item spacing={1}>
                <Grid item sm={4} xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography color="textSecondary" id="detailEmail" variant="body2">
                                {t("email")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography aria-labelledby="detailEmail" noWrap variant="body1">
                                {email}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={8} xs={12}>
                    <Button
                        color="secondary"
                        size="large"
                        type="button"
                        variant="contained"
                        onClick={() => setIsEditing(true)}
                    >
                        {t("updateEmail")}
                    </Button>
                </Grid>
            </Grid>
        </Fragment>
    );
};
